module.exports = __webpack_public_path__ + "img/file_compress.6132ed69.svg";